import { Backend } from '@shared/datastore/core';
import { SearchHistoryResultAjax } from './search-history.backend-model';

declare module '../core/backend' {
  interface BackendAjaxFetchTypes {
    searchHistory: SearchHistoryResultAjax;
  }
}

export const searchHistoryBackend: Backend<'searchHistory'> = {
  fetch: () => ({
    endpoint: `search/history.php`,
    isGaf: true,
    params: {},
  }),
  post: keyword => ({
    endpoint: `search/history.php`,
    isGaf: true,
    params: {},
  }),
};



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/search-history/search-history.backend.ts